import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'ud-ui/components/modal';
import { deleteTemplate } from 'modules/template-editor/store/templates/actions';
import { resetPressedState } from 'modules/template-editor/store/templates/templates';
import useTemplates from 'modules/template-editor/ui/hooks/use-templates';
import { useDispatchWithToast } from 'store/use-dispatch-with-toast';

function useDeleteModal() {
  const { t } = useLingui();
  const dispatch = useDispatch();
  const dispatchWithToast = useDispatchWithToast();
  const { activeTemplate, isProcessed, isFinished, currentProcess } = useTemplates();

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onSubmit = useCallback(() => {
    if (!activeTemplate) return;
    dispatchWithToast(deleteTemplate({ id: activeTemplate.id }), { error: msg`Не удалось удалить шаблон` });
  }, [activeTemplate, dispatchWithToast]);

  useEffect(() => {
    if (!isFinished) {
      return;
    }
    if (currentProcess !== 'delete template') {
      return;
    }
    close();
    dispatch(resetPressedState());
  }, [isFinished, close, dispatch, currentProcess]);

  const entityName = activeTemplate?.name;

  return {
    modal: (
      <Modal.Confirm
        show={isOpen}
        title={entityName ? t`Удалить шаблон «${entityName}»?` : t`Удалить шаблон?`}
        description={t`Это действие необратимо.`}
        isLoading={isProcessed}
        onConfirm={onSubmit}
        onCancel={close}
      />
    ),
    close,
    open,
  };
}

export default useDeleteModal;
